export default __webpack_public_path__ + "static/wide-silhouette-cropped-e81bbc694d3038013994c3fc336af725.png";